var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmittingAnalogClock lxn-margin-auto lxn-overflow-hidden lxn-border-round lxn-pos-rel",style:({width: (_vm.size + 10) + 'px', height: (_vm.size + 10) + 'px'}),attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }